module.exports = __webpack_public_path__ + "assets/img/peterpark.6c958bb8.png";